<template>
    <div v-if="visible" class="fixed z-20 inset-0 drop-shadow-3xl transition-opacity bg-gray-500 bg-opacity-70"
         @keydown.esc="close">
        <div class="h-screen p-4 overflow-y-auto flex justify-center">
            <div class="flex flex-col my-auto sm:align-middle max-w-7xl">
                <ToolbarSottoProgetto :id="id" @update:tabindex="$emit('update:tabindex',$event)" class="self-center"
                                      :tabindex="tabindex"></ToolbarSottoProgetto>
                <div class="bg-white">
                    <ViewForm @save="$emit('savePreference', $event)"
                              @chiudi="chiudi"
                              class="p-10 lg:px-20 lg:py-14"
                              v-if="tabindex === 5">
                    </ViewForm>
                    <SottoProgettoForm @saved="$emit('saved', $event)" :create="false" @chiudi="chiudi" :id="id"
                                       :cliente_id="cliente_id"
                                       class="p-10 lg:p-20"
                                       v-if="tabindex === 0"></SottoProgettoForm>

                    <FlagForm
                        v-if="tabindex === 1"
                        @chiudi="chiudi"
                        :id="id"
                        :nota="nota"
                        @update:nota="$emit('update:nota', $event)"
                        :tags="tags"
                        @update:tags="$emit('update:tags', $event)"
                        @save="$emit('manualSave')"
                        class="p-5"
                        @update:waiting="$emit('update:waiting', $event)"
                        :waiting="$attrs.waiting"
                    ></FlagForm>

                    <InfoPolicy
                        v-if="tabindex === 8"
                        @chiudi="chiudi"
                        :infoPolicy="infoPolicy"
                        :dataOfferta="dataOfferta"
                        :terminiPagamento="terminiPagamento"
                        @update:infoPolicy="$emit('update:infoPolicy', $event)"
                        @update:dataOfferta="$emit('update:dataOfferta', $event)"
                        @update:terminiPagamento="$emit('update:terminiPagamento', $event)"
                        @save="$emit('savePolicy')"
                        class="p-5"
                        @update:waiting="$emit('update:waiting', $event)"
                        :waiting="$attrs.waiting"
                    ></InfoPolicy>

                    <Sconto
                        v-if="tabindex === 9"
                        @chiudi="chiudi"
                        :sconto="sconto"
                        @update:sconto="$emit('update:sconto', $event)"
                        @save="$emit('saveSconto')"
                        class="p-5"
                        @update:waiting="$emit('update:waiting', $event)"
                        :waiting="$attrs.waiting"
                    ></Sconto>

                    <ImportaSottoprogetto
                        v-if="tabindex === 7"
                        @chiudi="chiudi"
                        @save="$emit('import', $event)"
                        class="p-5"
                        :waiting="$attrs.waiting"
                    ></ImportaSottoprogetto>

                    <EsportaSottoprogetto :id="id" :titolo="sottoprogetto"
                                          class="p-10 lg:px-28 lg:py-16 lg:min-w-[610px]" @chiudi="chiudi"
                                          v-if="tabindex === 2"></EsportaSottoprogetto>

                    <FeeRebateForm
                        v-if="tabindex === 3"
                        :fee="fee"
                        :sections="sections.map((s:any, idx)=>{return {id:idx, titolo:s.titolo}})"
                        @update:fee="$emit('update:fee',$event)"
                        @applica_mark_up_a_tutti="$emit('applica_mark_up_a_tutti', $event)"
                        :rebate="rebate"
                        @update:rebate="$emit('update:rebate',$event)"
                        :default_markup="default_markup"
                        @update:default_markup="$emit('update:default_markup',$event)"
                        @chiudi="chiudi" class="p-10 lg:p-20"></FeeRebateForm>

                    <CambioValutaForm
                        v-if="tabindex === 4"
                        @update:valute="$emit('update:valute',$event)"
                        :valute="valute"
                        @chiudi="chiudi"
                        class="p-10 lg:p-20"
                    ></CambioValutaForm>

                    <div
                        class="p-10"
                        v-if="tabindex === 6">
                        <div class="">
                            <p class="font-bold mb-3">Storico vendite</p>
                            <p class="mb-3">Voui copiare i valori delle celle "Budget Imponibile" sulle celle "Storico
                                vendite" laddove vuote?</p>
                        </div>
                        <div class="flex justify-end">
                            <NextButton variant="outline-secondary"
                                        @click="chiudi"
                                        class="col-start-4 col-span-3 py-2 px-4">
                                Chiudi
                            </NextButton>
                            <NextButton variant="primary"
                                        @click="$emit('copiaStoricoVendite')"
                                        class="col-span-3 ml-4 py-2 px-4">
                                Sì
                            </NextButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import ToolbarSottoProgetto from "@/components/ToolbarSottoProgetto.vue";
import ModalSottoProgetto from "@/components/ModalSottoProgetto.vue";
import SottoProgettoForm from "@/components/SottoProgettoForm.vue";
import FeeRebateForm from "@/components/FeeRebateForm.vue";
import EsportaSottoprogetto from "@/components/EsportaSottoprogetto.vue";
import FlagForm from "@/components/FlagForm.vue";
import CambioValutaForm from "@/components/CambioValutaForm.vue";
import ViewForm from "@/components/ViewForm.vue";
import NextButton from "@/components/NextButton.vue";
import ImportaSottoprogetto from "@/components/ImportaSottoprogetto.vue";
import InfoPolicy from "@/components/InfoPolicy.vue";
import Sconto from "@/components/Sconto.vue";

@Options({
    name: 'AzioniSottoProgetto',
    components: {
        Sconto,
        InfoPolicy,
        ImportaSottoprogetto,
        NextButton,
        ViewForm,
        CambioValutaForm,
        FlagForm,
        FeeRebateForm,
        SottoProgettoForm,
        EsportaSottoprogetto,
        ToolbarSottoProgetto,
        Modal,
        ModalSottoProgetto
    },
    props: {
        id: [String, Number],
        visible: Boolean,
        tabindex: Number,
        sottoprogetto: String,
        fee: Array,
        sections: Array,
        rebate: Array,
        valute: Array,
        default_markup: [String, Number],
        nota: String,
        tags: Array,
        infoPolicy: String,
        dataOfferta: String,
        terminiPagamento: String,
        sconto: [Number, String],
        cliente_id: {
            type: [Number, String],
            required: false
        }
    }
})
export default class AzioniSottoProgetto extends Vue {
    visible!: boolean

    chiudi() {
        this.$emit('update:visible', false)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
